import { render, staticRenderFns } from "./hesapdegistir.vue?vue&type=template&id=08f4aab7&"
import script from "./hesapdegistir.vue?vue&type=script&lang=js&"
export * from "./hesapdegistir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports